module.exports = __webpack_public_path__ + "img/arricon.66d2b983.png";